import { getNewNotifications, getNewNotificationsCount } from '../redux/actions/eventsApi';
import { showNewNotificationToast } from '../redux/notificationMiddleware.helpers';
import { isOpenKnotsBidNotificationPayload } from './openKnotsBidLifecycle';

/**
 * @param {import('@reduxjs/toolkit').Store} store
 * @param {{ showGenericCountToast?: boolean, selectedBuyer?: string|null }} [options]
 */
export async function refreshNotificationCenter(store, options = {}) {
  const selectedBuyer =
    options.selectedBuyer !== undefined
      ? options.selectedBuyer
      : localStorage.getItem('associatedBroker');
  const platform_role = localStorage.getItem('platform_role');
  const userUlId =
    platform_role === 'broker' ? localStorage.getItem('brokerUlid') : localStorage.getItem('loggedUserUlid');
  if (!userUlId) return null;

  const buyerOrg = selectedBuyer === '' ? null : selectedBuyer;
  const queryWithCat = {
    buyerOrganizationULID: buyerOrg,
    organizationULID: userUlId,
    limit: 3,
    cursor: 0,
  };

  const notifResult = await store.dispatch(getNewNotifications(queryWithCat));
  const latestCreatedAt = store.getState().app.events.newNotificationList[0]?.created_at;

  if (options.showGenericCountToast && latestCreatedAt) {
    const countState = await store.dispatch(
      getNewNotificationsCount({
        organizationULID: userUlId,
        timeStamp: latestCreatedAt,
      })
    );
    const { meta, payload } = countState || {};
    if (meta && meta.requestStatus === 'fulfilled' && payload !== 0) {
      showNewNotificationToast(payload, buyerOrg);
    }
  }

  return notifResult;
}

/**
 * Generic count toast is redundant when Open Knots bid lifecycle WS will show a specific toast.
 * @param {unknown} notificationCreatedPayload
 */
export function shouldShowGenericCountToastForNotificationCreated(notificationCreatedPayload) {
  return !isOpenKnotsBidNotificationPayload(notificationCreatedPayload);
}
